<div class="modal__content">
    <h2>{{ $t('modals.login.title') }}</h2>
    <form class="form" @submit.prevent="activeValidation = true; onSubmit();">
        <div class="form__group">
            <label v-t="'modals.login.email'"></label>
            <input :class="{alert: errors.email && activeValidation}" :disabled='isSubmitting' name="email" type="text" :placeholder="$t('modals.login.email-placeholder')" v-model="email" autocorrect="off" autocapitalize="none" />
            <div class="form__group-alert" v-if="errors.email && activeValidation" v-t="'modals.register.alerts.errorNoValidEmail'"></div>
        </div>
        <div class="form__group">
            <label v-t="'modals.login.password'"></label>
            <input :class="{alert: errors.password && activeValidation}" :disabled='isSubmitting' name="password" type="password" :placeholder="$t('modals.login.password-placeholder')" v-model="password" />
            <div class="form__group-alert" v-if="errors.password && activeValidation" v-t="'modals.register.alerts.errorNoValidPassword'"></div>
        </div>

        <vue-turnstile :site-key="siteKey" v-model="token" :theme="turnstileTheme" render-on-mount=true />

        <div class="form__group">
            <button class="btn btn-full" type="submit" :disabled='(isSubmitting || !token)' :class="{'disabled': (isSubmitting || !token) }">{{ $t('modals.login.loggedin') }}</button>
        </div>
        <div class="form__group">
            <span><a class="link" @click="doLostPassword()">{{ $t('modals.login.lostpassword') }}</a></span>
        </div>
        <div class="form__group nopad">
            <h3>{{ $t('modals.login.notyetregistered') }}</h3>
        </div>
        <div class="form__group nopad">
            <a class="btn btn-green" @click="doRegister()">{{ $t('modals.register.title') }}</a>
        </div>
    </form>
</div>
